import { render, staticRenderFns } from "./AllegacyTermsFeeSchedule.vue?vue&type=template&id=296e0351&scoped=true"
import script from "./AllegacyTermsFeeSchedule.vue?vue&type=script&lang=ts"
export * from "./AllegacyTermsFeeSchedule.vue?vue&type=script&lang=ts"
import style0 from "./AllegacyTermsFeeSchedule.vue?vue&type=style&index=0&id=296e0351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296e0351",
  null
  
)

export default component.exports